var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mohg-slider",
      attrs: {
        tabindex: "0",
        role: "slider",
        "aria-valuemin": _vm.min,
        "aria-valuemax": _vm.max,
        "aria-valuenow": _vm.ariaValueNow,
        "aria-valuetext": _vm.ariaValueText,
        "aria-label": _vm.ariaLabel,
      },
      on: {
        touchstart: function ($event) {
          $event.stopPropagation()
          return _vm.updateStart($event)
        },
        mousedown: function ($event) {
          $event.stopPropagation()
          return _vm.updateStart($event)
        },
        focus: _vm.handleFocus,
        blur: _vm.handleBlur,
        keydown: _vm.handleKeydown,
        keyup: _vm.handleKeyup,
      },
    },
    [
      _c("div", { ref: "background", staticClass: "background" }),
      _vm._v(" "),
      _c("div", {
        staticClass: "fill",
        style: [{ width: _vm.progress + "%" }],
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "handle",
        style: [{ "margin-left": _vm.progress + "%" }],
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }